import * as React from 'react';
import { UIText1, UIText2, Button } from '@cian/ui-kit';

import { SpecificationTooltip } from './parts/SpecificationTooltip';
import * as styles from './Specifications.css';
import { SPECIFICATIONS_ICON_MAP } from '../../constants/specifications';
import { ISpecificationItem } from '../../types/newbuilding/specification';
import { Layout } from '../Layout';

export interface ISpecificationsProps {
  specifications: ISpecificationItem[];
  onClick(): void;
}

export const Specifications: React.FC<ISpecificationsProps> = ({ specifications, onClick }) => {
  return (
    <Layout>
      <div className={styles['container']}>
        <div className={styles['specifications']} data-testid="SpecificationList">
          {specifications.map(
            ({ itemType, title, value, tooltipText }) =>
              title && (
                <div key={itemType} className={styles['specification']}>
                  {SPECIFICATIONS_ICON_MAP[itemType]}
                  <div className={styles['text']}>
                    <UIText2 color={'text-secondary-default'} data-testid="SpecificationTitle">
                      {title}
                    </UIText2>
                    <div className={styles['value']} data-testid="SpecificationValue">
                      <UIText1 fontWeight={'bold'}>{value || '—'}</UIText1>
                      {tooltipText && <SpecificationTooltip text={tooltipText} />}
                    </div>
                  </div>
                </div>
              ),
          )}
        </div>
        <Button size="M" theme="stroke_primary" onClick={onClick}>
          Все характеристики комплекса
        </Button>
      </div>
    </Layout>
  );
};
